import { Multiselect } from '../lib/multiselect'

export default class extends Multiselect {
  static values = {
    dropdownHeight: { type: Number, default: 200 },
    dropdownPosition: { type: String, default: 'absolute' },
    dropdownShadow: { type: String, default: 'none' },
    singleSelect: { type: Boolean, default: false }
  }

  initialize() {
    this.setupEventListeners();
    this.toggleSubmitButtonState();
  }

  connect() {
    super.connect();
    this.updateDropdownStyles();
  }

  setupEventListeners() {
    this.element.addEventListener('multiselect-removed', (event) => this.handleMultiselectChange(event));
    this.element.addEventListener('multiselect-added', (event) => this.handleMultiselectChange(event));
  }

  handleMultiselectChange(event) {
    const submitButton = event.currentTarget.closest('form').querySelector('.multiselect__submit');
    if (submitButton) {
      submitButton.disabled = false;
      submitButton.style.opacity = '1.0';
    }
  }

  toggleSubmitButtonState() {
    const selectedValue = this.element.dataset.multiselectSelectedValue;
    const submitButton = this.element.closest('form').querySelector('.multiselect__submit');

    if (submitButton) {
      const isEmptySelection = selectedValue === '[]';
      submitButton.disabled = !isEmptySelection;
      submitButton.style.opacity = isEmptySelection ? '1.0' : '0.2';
    }
  }

  updateDropdownStyles() {
    if (this.hasDropdownTarget) {
      // Update dropdown height
      this.dropdownTarget.style.maxHeight = `${this.dropdownHeightValue}px`;
      this.dropdownTarget.style.overflowY = 'auto';

      // Update dropdown position and shadow
      this.dropdownTarget.style.position = this.dropdownPositionValue;
      this.dropdownTarget.style.boxShadow = this.dropdownShadowValue; 
      this.dropdownTarget.classList.add('no-scrollbar')
    }
  }

  // Override the toggleItem method to implement single-select behavior.
  // These functions are used by the multiselect library and we need to override them to implement single-select behavior.
  toggleItem(input) {
    if (this.singleSelectValue) {
      // Clear any existing selection
      if (this.selectedValue.length > 0) {
        const previousValue = this.selectedValue[0].value;
        this.uncheckItem(previousValue);
      }
      
      const item = {
        text: input.dataset.text,
        value: input.dataset.value
      };

      if (input.checked) {
        this.selectedValue = [item];
        this.element.dispatchEvent(new CustomEvent("multiselect-added", { detail: { item: item } }));
      } else {
        this.selectedValue = [];
        this.element.dispatchEvent(new CustomEvent("multiselect-removed", { detail: { id: item.value } }));
      }
    } else {
      // Call original implementation for multi-select 
      super.toggleItem(input);
    }
  }

}
